import Vue from "vue";

export default new Vue({
  methods: {
    name() {},
  },
});
